import { Classes as CoreClasses } from '@mc/react-core';
import * as UiClasses from './common/classes';
import './ui.scss';

const { BREADCRUMBS, BREADCRUMB, ...otherCoreClasses } = CoreClasses;
const Classes = { ...otherCoreClasses, ...UiClasses };

export { Classes };

export {
  NonIdealState,
  Container,
  VerticalLayout,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  D3,
  D4, // Text, // FormGroup,
} from '@mc/react-core';

export { ThemeContextProvider } from './theme/ThemeContextProvider';
export { TestThemeSwitcher } from './theme/TestThemeSwitcher';

export { MultiSelectSearch } from './multiselect/MultiSelectSearch';
export { ImageGalleryInput, ImageMetaProps } from './image-gallery/ImageGalleryInput';
export { VideoThumbnail } from './image-gallery/VideoThumbnail';
export { Tabs, Tab } from './tabs';
export { Tag } from './tag/Tag';
export { TagGroup } from './tag-group/TagGroup';
export { AppError } from './error/AppError';
export { Table } from './table/Table';
export {
  TableColumn,
  TableCellProps,
  BaseTableProps,
  TableCellRender,
  TitleCellRender,
  TableFooterProps,
  TableFooterRender,
  GetRowPropsType,
  ClassicTableColumn,
} from './table/TableProps';
export { ColumnType } from './table/ColumnTypes';
export { AlignmentType } from './table/Alignment';
export { DateCell } from './table/DateCell';
export { DateTimeCell } from './table/DateTimeCell';
export { CurrencyCell } from './table/CurrencyCell';
export { CurrencyDecimalCell } from './table/CurrencyDecimalCell';
export { DecimalCell } from './table/DecimalCell';
export { IntegerCell } from './table/IntegerCell';
export { TextCell } from './table/TextCell';
export { LabelValue } from './label-value/LabelValue';
export { LabelValueList } from './label-value/LabelValueList';

export { useRowsData } from './rows-data/useRowsData';
export { RowsDataProvider } from './rows-data/RowsDataProvider';
export { FinalTableDataProvider } from './final-table/FinalTableDataProvider';
export { useCheckIds, CheckIdsProps } from './rows-data/useCheckIds';
export * from './rows-data/types';

export { Row, Col } from './row';
export {
  showConfirm,
  showInfo,
  showDeleteConfirm,
  showApiError,
  showUnknownApiError,
  showValidationApiError,
} from './modal/modalFunctions';
// export { DropzoneField } from './form/DropzoneField';

export * from './form/utils';

import * as VF from './form/VF';
export { VF };
export {
  Filters,
  filtersComputeQueryFilter,
  FilterDef,
  FilterListItem,
  FilterFieldType,
  serializeFilter,
  filterUrlParamName,
  ExtendedFilter,
} from './filter/Filters';
export { InputAddons } from './input-addons/InputAddons';
export { StringInput } from './string/StringInput';
export { NumberInput } from './number/NumberInput';
export { TimeInput } from './datetime/TimeInput';
export { WizardFooter, WizardFooterProps } from './wizard/WizardFooter';
export {
  WizardForm,
  WizardChangeStepOptions,
  WizardCloseOptions,
  WizardRenderProps,
  WizardHeaderFooterRenderProps,
  WizardStepRenderProps,
  WizardStep,
  IWizardForm,
  WizardFormProps,
} from './wizard/WizardForm';
export { Wysiwyg, WysiwygProps } from './wysiwyg/Wysiwyg';
export { Space } from './space/Space';
export { Divider } from './divider/Divider';
export { TextAreaInput } from './text-area/TextAreaInput';
export { FileInput } from './file/FileInput';
export { MultiFileInput } from './file/MultiFileInput';
export { DateInput } from './datetime/DateInput';
export { DateTimeInput } from './datetime/DateTimeInput';
export { DatePicker } from './datetime/DatePicker';
export { TimePicker } from './datetime/TimePicker';
export { MonthPicker } from './datetime/MonthPicker';
export { MonthInput } from './datetime/MonthInput';
export { DayMonthInput } from './datetime/DayMonthInput';
export { Switch } from './switch/Switch';
export { ProgressBar } from './progress-bar/ProgressBar';
export { SelectBox } from './selectbox/SelectBox';
export { SelectBoxSuggestText } from './selectbox/SelectBoxSuggestText';
export { ColorSelect } from './colorselect/ColorSelect';
export { Autocomplete } from './autocomplete/Autocomplete';
export { AutocompleteSuggestText } from './autocomplete/AutocompleteSuggestText';
export { Fulltext } from './fulltext/Fulltext';
export { HorizontalLoader } from './horizontal-loader/HorizontalLoader';
export { RadioGroup, Radio } from './radio';
export { RadioButton } from './radio/RadioButton';
export { Checkbox } from './checkbox/Checkbox';
export { CheckboxButton } from './checkbox/CheckboxButton';
export { Label } from './label/Label';
export { FormGrid } from './grid/FormGrid';
export { Spinner, SpinnerSize } from './spinner/Spinner';
export { Navbar } from './navbar/Navbar';
export { NavbarFullText } from './fulltext/NavbarFulltext';
export { NavMenu, MenuItemProps, NAVMENU_SEPARATOR } from './navbar/NavMenu';
export { Layout } from './layout/Layout';
export {
  AppLayoutBlank,
  AppLayoutBase,
  AppLayoutViewDetail,
  SidePanelLayoutProps,
  SidePanelProps,
  SidePanelItem,
  SidePanelItemActionEnum,
  ContentFunction,
  SidePanelItemsPlacementEnum,
  HeaderPlacementEnum,
} from './app/AppLayout';

export {
  NavBarProps,
  NavBarAppMenuProps,
  NavBarMenuLayoutProps,
} from './navbar/NavBarMenuLayout';

export { compareStrings } from './data-table/dataUtils';

export { toaster, ToastConfig } from './toaster/ToasterImplementation';
export { Icon } from './icon/Icon';
export { Button, ButtonStyle } from './button/Button';
export { NavbarButton } from './button/NavbarButton';
export { CloseButton } from './button/CloseButton';
export { Title, TitleProps } from './typography/Title';
export { Text, TextProps } from './typography/Text';
export { ButtonToolbar } from './button-toolbar/ButtonToolbar';
export { ButtonGroup } from './button-group/ButtonGroup';
export { Card } from './card/Card';
export { List } from './list/List';
export { ListItem } from './list/ListItem';
export { ListHeader } from './list/ListHeader';
export { GroupContainer } from './GroupContainer/GroupContainer';
export { VirtualList, RowRenderer } from './virtual-list/VirtualList';
export { CheckStatus, CommonRenderer } from './virtual-data/VirtualData';
export { BadgeCount } from './badge-count/BadgeCount';

export * from './final-table/FinalTable';
export * from './final-table/useFinalTable';
export * from './final-table/useFinalTableData';
export * from './final-table/FinalTableProps';

export { FormattedText } from './formatted-text/FormattedText';
export { DataTable } from './data-table/DataTable';
export {
  ClientTable,
  ClientFilterDef,
  ClientFilter,
} from './data-table/ClientTable';
export { DataTableExtra } from './data-table/DataTableExtra';
export { Deleted } from './deleted/Deleted';
export { Skeleton } from './skeleton/Skeleton';
export { Tile } from './tile/Tile';
export { TileWrapper } from './tile/TileWrapper';
export { ValueTile } from './tile/ValueTile';
export { Block } from './block/Block';
export { Link, LinkProps } from './link/Link';
export * from './common/props';
export { ColorType } from './common/colors';
export { Callout } from './callout/Callout';
export { Menu } from './menu/Menu';
export { MenuItem } from './menu/MenuItem';
export { MenuDivider } from './menu/MenuDivider';
export { Dialog } from './dialog/Dialog';
export { DialogBody } from './dialog/DialogBody';
export { DialogFooter } from './dialog/DialogFooter';
export { Popup, PopupPosition } from './popover/Popup';
export { Tooltip } from './tooltip/Tooltip';
export { NoData } from './no-data/NoData';
export { TestEnvironmentBar } from './test-environment-bar/TestEnvironmentBar';
export { Pagination } from './pagination/Pagination';
export { PaginationTable } from './data-table/PaginationTable';
export { Badge } from './badge/Badge';
export { Note } from './note/Note';
export { WaitingModal } from './WaitingModal/WaitingModal';
export { SliderInput } from './slider/SliderInput';
export { RangeSliderInput } from './slider/RangeSliderInput';
export { PasswordInput } from './password/PasswordInput';
export { Rz } from './rz/Rz';
export { DetailMenu } from './detail-menu/DetailMenu';
export { DetailMenuItem } from './detail-menu/DetailMenuItem';
export { DetailMenuLabel } from './detail-menu/DetailMenuLabel';
export { Breadcrumbs } from './breadcrumbs/Breadcrumbs';
export { Breadcrumb } from './breadcrumbs/Breadcrumb';
export {
  Calendar,
  CalendarProps,
  CalendarViewConfig,
  EventProps,
  CalendarEventProps,
  DayheaderProps,
} from './calendar/Calendar';
export { CalendarDaysInterval, CalendarTimeInterval } from './calendar/utils';
export { GLOBAL_SETTINGS_CALENDAR_VIEW_KEY } from './calendar/consts';
export {
  useCalendar,
  UseCalendarData,
  UseCalendarConfig,
  UseCalendarProps,
} from './calendar/useCalendar';
export { FormGroup } from './form-group/FormGroup';
export {
  DayWeekPickerGroup,
  DayWeekPickerGroupProps,
  MonthYear,
} from './calendar/DayWeekPickerGroup';
export {
  DayWeekPicker,
  DayWeekPickerProps,
  StringDayWeekPicker,
  StringDayWeekPickerProps,
} from './calendar/DayWeekPicker';
export {
  ModalManager,
  ModalComponentProps,
  ModalComponent,
} from './modal/ModalManager';
export {
  getDataTableProps,
  getPaginationTableProps,
  getVirtualListProps,
} from './common/utils';
export {
  TimeLine,
  Step,
  StepStatusEnum,
  TimeLineProps,
} from './time-line/TimeLine';

export { ThemeProps, themes } from './themes';

export { InverseBgProvider } from './theme/InverseBg';
